import { render, staticRenderFns } from "./InfoAllegro.vue?vue&type=template&id=50ddbe44"
import script from "./InfoAllegro.vue?vue&type=script&lang=js"
export * from "./InfoAllegro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports